import { cva, type VariantProps } from 'class-variance-authority';

/**
 * Grid variant styles using Class Variance Authority (CVA)
 *
 * Defines responsive column and gap options for the Grid component.
 * All styles use design tokens from the HEN Design System.
 *
 * ## Columns (base, responsive at md, lg, and xl breakpoints)
 * - 1 through 6 columns
 *
 * ## Gap Options
 * - xxs through 3xl matching design tokens
 */
export const gridVariants = cva('grid', {
  variants: {
    columns: {
      1: 'grid-cols-1',
      2: 'grid-cols-2',
      3: 'grid-cols-3',
      4: 'grid-cols-4',
      5: 'grid-cols-5',
      6: 'grid-cols-6',
    },
    'columns-md': {
      1: 'md:grid-cols-1',
      2: 'md:grid-cols-2',
      3: 'md:grid-cols-3',
      4: 'md:grid-cols-4',
      5: 'md:grid-cols-5',
      6: 'md:grid-cols-6',
    },
    'columns-lg': {
      1: 'lg:grid-cols-1',
      2: 'lg:grid-cols-2',
      3: 'lg:grid-cols-3',
      4: 'lg:grid-cols-4',
      5: 'lg:grid-cols-5',
      6: 'lg:grid-cols-6',
    },
    'columns-xl': {
      1: 'xl:grid-cols-1',
      2: 'xl:grid-cols-2',
      3: 'xl:grid-cols-3',
      4: 'xl:grid-cols-4',
      5: 'xl:grid-cols-5',
      6: 'xl:grid-cols-6',
    },
    gap: {
      xxs: 'gap-xxs',
      xs: 'gap-xs',
      sm: 'gap-sm',
      md: 'gap-md',
      lg: 'gap-lg',
      xl: 'gap-xl',
      '2xl': 'gap-2xl',
      '3xl': 'gap-3xl',
    },
  },
  defaultVariants: {
    columns: 1,
    gap: 'lg',
  },
});

export type GridVariantProps = VariantProps<typeof gridVariants>;
